import React, { Component } from 'react';

import Link from 'react-router-dom/NavLink';
import SortableTable from '../../../shared/components/SortableTable';
import Button from '../../../shared/components/Button';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import DateRange from '../../../shared/components/DateRange';

import { formatStatus, emojiUrlForRating } from '../../../shared/utils';

class PlaceholderCampaignList extends Component {
  render(){
    return (
      <div className='DashboardCampaignList'>
        <SortableTable
          columns={[
            {name:'status', width:15, sortable:true},
            {name:'experience', width:20, sortable:true},
            {name:'budget', width:20, sortable:true},
            {name:'completions', width:12, sortable:true},
            {name:'adjoyability', width:13, sortable:true},
            {name:'', width:20}
          ]}
          onSort={() => {}}
        >
          <tr>
            <td>
              <strong>{formatStatus('live')}</strong>
            </td>
            <td>
              <h6>
                <Link to={'#'}>Summer Campaign</Link>
              </h6>
              <strong>Brand 1</strong>
              <br />
              <DateRange launchDate={1503337847305} />
            </td>
            <td><MoneyDisplay>10000</MoneyDisplay></td>
            <td>7,856</td>
            <td>
              <span>
                <img
                  src={emojiUrlForRating(3.2)}
                  className='EmojiRating'
                  alt='rating'
                />
                &nbsp;&nbsp;
                <span>{(3.2 + 1).toFixed(2)}</span>
              </span>
            </td>
            <td>
              <div className='pull-right'>
                <Button
                  className='CampaignResultsButton'
                  size='sm'
                  textColor='#666666'
                  borderColor='#cccccc'
                  backgroundColor='#ededed'
                >
                  Results
                </Button>
                &nbsp;&nbsp;
                <Button
                  size='sm'
                  textColor='#666666'
                  borderColor='#cccccc'
                  backgroundColor='#ededed'
                >
                  Pause
                </Button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <strong>{formatStatus('live')}</strong>
            </td>
            <td>
              <h6>
                <Link to={'#'}>Winter Campaign</Link>
              </h6>
              <strong>Brand 2</strong>
              <br />
              <DateRange launchDate={1503337847305} />
            </td>
            <td><MoneyDisplay>7000</MoneyDisplay></td>
            <td>496</td>
            <td>
              <span>
                <img
                  src={emojiUrlForRating(1.5)}
                  className='EmojiRating'
                  alt='rating'
                />
                &nbsp;&nbsp;
                <span>{(1.5 + 1).toFixed(2)}</span>
              </span>
            </td>
            <td>
              <div className='pull-right'>
                <Button
                  className='CampaignResultsButton'
                  size='sm'
                  textColor='#666666'
                  borderColor='#cccccc'
                  backgroundColor='#ededed'
                >
                  Results
                </Button>
                &nbsp;&nbsp;
                <Button
                  size='sm'
                  textColor='#666666'
                  borderColor='#cccccc'
                  backgroundColor='#ededed'
                >
                  Pause
                </Button>
              </div>
            </td>
          </tr>
        </SortableTable>
      </div>
    );
  }
}

export default PlaceholderCampaignList;



// WEBPACK FOOTER //
// ./src/routes/AgencyCampaignsDashboard/components/PlaceholderCampaignList.js